var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "gfu-grid__cell",
          attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
        },
        [
          _c(
            "field",
            _vm._b(
              { attrs: { small: true } },
              "field",
              { ..._vm.$attrs, ..._vm.$props },
              false
            ),
            [
              _c(
                "div",
                {
                  staticClass:
                    "gfu-field-auto-complete__container gfu-field-auto-complete__chevron",
                },
                [
                  _vm.isReadOnly
                    ? _c("input", {
                        class: ["gfu-field__input gfu-field__input--small"],
                        attrs: {
                          readonly: true,
                          disabled: _vm.isReadOnly,
                          placeholder: _vm.placeholder,
                          "data-qa": "auto-complete-input",
                        },
                        on: { focus: _vm.onInputFocus },
                      })
                    : _c(
                        "toggle-trigger",
                        {
                          ref: "toggleTrigger",
                          attrs: {
                            tag: "div",
                            tabindex: "0",
                            "active-class": "gfu-field-select__trigger--active",
                            "handle-click": false,
                            "focus-children": true,
                          },
                          on: { collapse: _vm.onCollapse },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchTerm,
                                expression: "searchTerm",
                              },
                            ],
                            class: ["gfu-field__input gfu-field__input--small"],
                            attrs: {
                              placeholder: _vm.placeholder,
                              "data-qa": "auto-complete-input",
                            },
                            domProps: { value: _vm.searchTerm },
                            on: {
                              focus: _vm.onInputFocus,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.searchTerm = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.oldIDs.length && !_vm.isReadOnly
                            ? _c("button", {
                                staticClass:
                                  "gfu-field-auto-complete__clear gfu-field-auto-complete__clear--small gfu-btn _fa _fa--times",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.onClickClear.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "toggle-container",
                    {
                      staticClass: "gfu-field-select__content",
                      attrs: {
                        tag: "div",
                        tabindex: "1",
                        "active-class": "gfu-field-select__content--expanded",
                        "data-qa": "select-content",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "gfu-field-select__content-wrapper" },
                        [
                          _vm.selectedItems.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "gfu-field-select__group-header",
                                },
                                [_vm._v("Selected items")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.selectedItems, function (item) {
                            return _c(
                              "div",
                              { key: `items-filter-checkbox-${item.value}` },
                              [
                                _c("checkbox-field", {
                                  attrs: {
                                    "display-name": item.name,
                                    "checked-value": item.value,
                                    inline: true,
                                    disabled:
                                      !_vm.canSelectMoreItems &&
                                      !_vm.isItemSelected(item.value),
                                    condensed: true,
                                    "data-qa": `items-filter-checkbox:${item.value}`,
                                  },
                                  on: { input: _vm.handleInput },
                                  model: {
                                    value: _vm.oldIDs,
                                    callback: function ($$v) {
                                      _vm.oldIDs = $$v
                                    },
                                    expression: "oldIDs",
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "gfu-field-select__group-header" },
                            [_vm._v(_vm._s(_vm.groupTitleLabel))]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.pagedFilteredItems, function (item) {
                            return _c(
                              "div",
                              { key: `items-filter-checkbox-${item.value}` },
                              [
                                _c("checkbox-field", {
                                  attrs: {
                                    "display-name": item.name,
                                    "checked-value": item.value,
                                    inline: true,
                                    disabled:
                                      !_vm.canSelectMoreItems &&
                                      !_vm.isItemSelected(item.value),
                                    condensed: true,
                                    "data-qa": `items-filter-checkbox:${item.value}`,
                                  },
                                  on: { input: _vm.handleInput },
                                  model: {
                                    value: _vm.newIDs,
                                    callback: function ($$v) {
                                      _vm.newIDs = $$v
                                    },
                                    expression: "newIDs",
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("load-more-trigger", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.canLoadMoreFilteredItems,
                                expression: "canLoadMoreFilteredItems",
                              },
                            ],
                            on: { "load-more": _vm.loadMoreFilteredItems },
                          }),
                          _vm._v(" "),
                          _c("progress-overlay", {
                            attrs: { visible: _vm.isProcessing, sticky: true },
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }